// extracted by mini-css-extract-plugin
export var fadeIn = "_8x-0";
export var panelInner = "_8x-2";
export var panelOuter = "_8x-1";